export default __webpack_public_path__ + "static/media/login-background.6d0f1fbb.jpg";